var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.006,
    viewBox: "0 0 22 22.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chat_copy",
    "data-name": "chat copy",
    d: "M15.408,0h-8.8a6.608,6.608,0,0,0-6.6,6.6v5.133a6.609,6.609,0,0,0,6.233,6.59v3.059a.624.624,0,0,0,.624.623.617.617,0,0,0,.438-.183l.688-.688a9.5,9.5,0,0,1,6.763-2.8h.653a6.608,6.608,0,0,0,6.6-6.6V6.6A6.608,6.608,0,0,0,15.408,0ZM6.241,10.633A1.467,1.467,0,1,1,7.708,9.167,1.468,1.468,0,0,1,6.241,10.633Zm4.767,0a1.467,1.467,0,1,1,1.467-1.467A1.468,1.468,0,0,1,11.008,10.633Zm4.767,0a1.467,1.467,0,1,1,1.467-1.467A1.468,1.468,0,0,1,15.775,10.633Z",
    transform: "translate(-0.008)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.6ef655c0a97a8de1b9344af8e85346ab.svg";
export { ForwardRef as ReactComponent };